import React from "react";

const Whatsapp = () => {
  return (
    <div class="fixed z-50 bottom-1 right-1 md:bottom-4 md:right-4  rounded-full animate-bounce ">
      <a
        href="https://wa.me/+919997112688"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://res.cloudinary.com/dfmnua4b7/image/upload/v1689793946/kc9uxxukqdrxfgqbl3hk.png"
          alt="WhatsApp"
          class="w-20 h-20"
        />
      </a>
    </div>
  );
};

export default Whatsapp;
